import {
  type Category,
  type ConfigUrls,
  type CategoriesResponse,
} from 'hb-react/backoffice/components/CategoriesList/types';
import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

import {
  type SavePositionRequest,
  type DeleteCategoryRequest,
  type UpdateCategoryRequest,
  type CreateCategoryRequest,
} from './requests.types';

export const getCategories = (
  configUrls: Pick<ConfigUrls, 'getCategoriesPath'>,
  signal?: AbortSignal,
) =>
  axios
    .get<CategoriesResponse>(configUrls.getCategoriesPath(), {
      signal,
    })
    .then(({ data }) => data);

export const savePosition = ({
  configUrls,
  categoryId,
  position,
}: SavePositionRequest) =>
  axios
    .patch<Category>(configUrls.savePositionPath(categoryId), {
      network_category: { row_order_position: position },
    })
    .then(({ data }) => data);

export const deleteCategory = ({
  configUrls,
  categoryId,
}: DeleteCategoryRequest) =>
  axios.delete(configUrls.deleteCategoryPath(categoryId));

export const updateCategory = ({
  configUrls,
  categoryId,
  payload,
}: UpdateCategoryRequest) =>
  axios.patch(configUrls.updateCategoryPath(categoryId), {
    network_category: payload,
  });

export const createCategory = ({
  configUrls,
  payload,
  type,
}: CreateCategoryRequest) =>
  axios.post(configUrls.createCategoryPath(), {
    network_category: { ...payload, categorized_type: type },
  });
